export const CARRIER_IDS = {
	WRB: 'p-19g61kzm10w4t',
	STARR: 'p-19g6jlvzblwqr',
	GAIG: 'p-19g6jlvzbmj18',
	INTERPLANETARY: 'interplanetary-19g6km2ndt71l',
};

export const PRODUCER_IDS = {
	POMI: 'p-19g6jlnnerv7e',
	FL_DEAN: 'francis-7uhb24xsluimt3ly', // FL Dean is a new partner and follows the new id format.
};

const SUBDOMAIN_ID_MAP = {
	berkleyah: {
		carrierId: CARRIER_IDS.WRB,
	},
	contractcoverage: {
		carrierId: CARRIER_IDS.GAIG,
	},
	fldean: {
		carrierId: CARRIER_IDS.GAIG,
		producerId: PRODUCER_IDS.FL_DEAN,
	},
	gaig: {
		carrierId: CARRIER_IDS.GAIG,
	},
	interplanetary: {
		carrierId: CARRIER_IDS.INTERPLANETARY,
	},
	pomi: {
		carrierId: CARRIER_IDS.GAIG,
		producerId: PRODUCER_IDS.POMI,
	},
	starr: {
		carrierId: CARRIER_IDS.STARR,
	},
};

export default SUBDOMAIN_ID_MAP;
